<template>
  <div>
    <component
        :is="calcNameSvg()"
        :kcpGroupId="kcpGroupId"
        :regionId="regionId"
        v-bind="values"
    />
  </div>
</template>

<script>

// import MaSvg from "@/components/svg/MaSvg(new)";
import McSvg from "@/components/svg/McSvg";
import D_Svg from "@/components/svg/D%Svg";
import DNoRf from "@/components/svg/DNoRf";
import Drf from "@/components/svg/Drf";
import Pd1 from "@/components/svg/Pd1";
import MaSvgRegion from "@/components/svg/MaSvgRegion";
import MaSvgRf from "@/components/svg/MaSvgRf";
import Pd3 from "@/components/svg/Pd3";
import Mb1Svg from "@/components/svg/Mb1Svg";
import Mb2Svg from "@/components/svg/Mb2Svg";
import Pd2 from "@/components/svg/Pd2";
import Pc3 from "@/components/svg/Pc3";
import Pc2 from "@/components/svg/Pc2";
import Pc1 from "@/components/svg/Pc1";
import Pb3 from "@/components/svg/Pb3";
import Pb2 from "@/components/svg/Pb2";
import Pb1 from "@/components/svg/Pb1";
import Pa3 from "@/components/svg/Pa3";
import Pa2 from "@/components/svg/Pa2";
import Pa1 from "@/components/svg/Pa1";
export default {
  name: "DialogSvg",
  components: {Pd3, Drf, DNoRf,  Mb1Svg, Mb2Svg, Pd2, Pd1, Pc3, Pc2, Pc1, Pb3, Pb2, Pb1, Pa3, Pa2, Pa1, D_Svg, MaSvgRegion,MaSvgRf, McSvg},
  props: {
    columnNum: null,
    kcpGroupId: null,
    regionId: null,
    regionName: null,
    sprKcpGroupId: null,
    sprKcpGroupName: null,
    uslName: null,
    foName: null,
    pb: null,
    row: null
  },
  computed:{
    values(){
      return {...this.row, ...this.$props}
    },
    uslId(){
      return this.row?.fo.id ?? 1
    }
  },
  methods: {
    calcNameSvg() {
      console.log('calcNameSvg')
      if (this.columnNum === 1)
      {
        if (this.kcpGroupId === 114)
          return 'Mb1Svg'
        if (this.kcpGroupId === 115)
          return 'Mb2Svg'
        if (this.regionId == null)
          return 'MaSvgRf';
        return 'MaSvgRegion';
      }
      if (this.columnNum === 2)
          return 'McSvg'
      if (this.columnNum === 3)
      {
        if (this.regionId === null && this.row.isRfLevel)
          return 'Drf'
        else if (this.regionId === null && !this.row.isRfLevel)
          return 'DNoRf'
        return 'D_Svg'
      }
      if (this.columnNum === 4)
      {
        if (this.regionId === null)
          return 'Pa'+ this.uslId;
        if (this.$consts.specialRegions.includes(this.regionId))
          return this.pb ? 'Pb'+ this.uslId : 'Pc'+ this.uslId;
        return 'Pd'+ this.uslId;
      }
    }
  },
}
</script>

<style scoped>
/*
old-color - new kcp color
#D50000 - #00599B
#FADEDE - #DEE9F2
#F3B8B8 - #99C0DD
*/
</style>